/* NUTREMYS v3.0 — Sommaire produit (nmqn) : auto-ordre + réparation d'ancre.
   Réordonne les liens du sommaire selon la position réelle de leur section
   et répare l'ancre "Ce qu'elles disent" (section renommée). N'agit que sur
   la page qui contient le sommaire ; sinon no-op. Aucune dépendance. */
(function () {
  function resolve(t) {
    if (!t) return null;
    t = String(t).replace(/^#/, '').trim();
    if (!t) return null;
    var el = null;
    try { el = document.getElementById(t); } catch (e) {}
    if (el) return el;
    try { el = document.querySelector('[id*="' + t + '"]'); } catch (e) {}
    return el;
  }

  function fix() {
    var nav = document.querySelector('.nmqn__inner');
    if (!nav) return;
    var links = [].slice.call(nav.querySelectorAll('.nmqn__link'));
    if (!links.length) return;

    // 1) Réparer l'ancre témoignages (l'ancienne #nm-testimonios n'existe plus).
    links.forEach(function (a) {
      var t = a.getAttribute('data-target') || '';
      var txt = a.textContent || '';
      if (t.indexOf('#') >= 0 || /testimonios/i.test(t) || /qu.?elles/i.test(txt)) {
        var sec = document.querySelector('[id*="nm_testimonios"]');
        if (!sec) {
          var nvc = document.querySelector('.nvc');
          if (nvc && nvc.closest) sec = nvc.closest('.shopify-section');
        }
        if (sec) a.setAttribute('data-target', 'nm_testimonios');
      }
    });

    // 2) Réordonner selon l'ordre RÉEL des sections dans le DOM (source order),
    //    immunisé contre le reflow du lazy-load (les positions Y ne sont pas fiables
    //    tant que le contenu différé n'est pas rendu).
    var items = links.map(function (a) {
      return { a: a, el: resolve(a.getAttribute('data-target')) };
    });
    items.sort(function (x, y) {
      if (!x.el && !y.el) return 0;
      if (!x.el) return 1;   // liens non résolus à la fin
      if (!y.el) return -1;
      if (x.el === y.el) return 0;
      var pos = x.el.compareDocumentPosition(y.el);
      if (pos & Node.DOCUMENT_POSITION_FOLLOWING) return -1; // x avant y
      if (pos & Node.DOCUMENT_POSITION_PRECEDING) return 1;  // x après y
      return 0;
    });
    items.forEach(function (o) {
      o.a.style.display = o.el ? '' : 'none';
      nav.appendChild(o.a);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fix);
  } else {
    fix();
  }
  window.addEventListener('load', fix);
})();
